export default "__VITE_ASSET__12201165__"